var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.status === _vm.STATUS_ACTIVE && _vm.isNew)?_c('span',{staticStyle:{"display":"inline","margin-left":"8px"}},[_c('badge',{attrs:{"type":"info"}},[_vm._v(" "+_vm._s(_vm.$t("COMMON.NEW"))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }